import { View } from './view.js';

// eslint-disable-next-line no-shadow
export enum LayoutDirection {
  top,
  right,
  bottom,
  left,
  horizontal,
  vertical,
  all,
}

function computeValue(
  dir: LayoutDirection | LayoutDirection[] = LayoutDirection.all,
  value = '1rem'
) {
  const directions = Array.isArray(dir) ? dir : [dir];
  let computedValue = '';
  if (directions.length === 0 || directions.includes(LayoutDirection.all)) {
    computedValue = value;
  } else {
    const top =
      directions.includes(LayoutDirection.top) ||
      directions.includes(LayoutDirection.vertical)
        ? value
        : '0';
    const bottom =
      directions.includes(LayoutDirection.bottom) ||
      directions.includes(LayoutDirection.vertical)
        ? value
        : '0';
    const left =
      directions.includes(LayoutDirection.left) ||
      directions.includes(LayoutDirection.horizontal)
        ? value
        : '0';
    const right =
      directions.includes(LayoutDirection.right) ||
      directions.includes(LayoutDirection.horizontal)
        ? value
        : '0';
    computedValue = `${top} ${right} ${bottom} ${left}`;
  }
  return computedValue;
}

View.prototype.padding = function padding(
  dir = LayoutDirection.all,
  value = '1rem'
) {
  return this.style('padding', computeValue(dir, value));
};

View.prototype.margin = function margin(
  dir = LayoutDirection.all,
  value = '1rem'
) {
  return this.style('margin', computeValue(dir, value));
};

declare module './view' {
  // eslint-disable-next-line no-shadow
  interface View {
    padding: (
      directions: LayoutDirection | LayoutDirection[],
      value?: string
    ) => this;
    margin: (
      directions?: LayoutDirection | LayoutDirection[],
      value?: string
    ) => this;
  }
}
